<template>
    <div
        :class="{
            'pointer-events-none': !isExpanded,
            'pointer-events-auto': isExpanded,
        }"
        class="w-24 py-10 pb-6 pl-10"
    >
        <router-link to="/home">
            <SVGSerifLogo :class="{ expand: isExpanded }" class="serif-logo -ml-1 h-8" />
        </router-link>
    </div>
</template>

<script setup>
import SVGSerifLogo from '@/assets/svg/serif-logo-updated.svg'

defineProps({
    isExpanded: {
        type: Boolean,
        default: false,
    },
})
</script>

<style>
@reference "@/tailwind.css";
.serif-logo .mark {
    @apply pointer-events-none ml-2 -translate-x-10 opacity-0 transition-all duration-200 ease-out;
}

.serif-logo.expand .mark {
    @apply pointer-events-auto translate-x-0 opacity-100 transition-all duration-200 ease-in;
}
</style>
